import React, {useContext, useEffect, useState} from "react";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import {FormattedMessage} from "react-intl";
import {withStyles} from "@mui/styles";
import {BeatLoader} from "react-spinners";
import FilterBlock from "components/filter/FilterBlock";
import ListingActiveFiltersBar from "components/Product/Table/ListingActiveFiltersBar";
import filterMenuStyle from "assets/jss/components/filterMenuStyle";
import {getFilterLabel} from "domain/helpers/filterTranslations";
import {FilterContext, FilterDispatchContext} from "contexts/filterContext";
import {primaryColor} from "assets/jss/main";

function Filters(props) {
    const {classes} = props;
    const {filters} = useContext(FilterContext);
    const dispatch = useContext(FilterDispatchContext);
    const [value, setValue] = useState('0');
    const [lastSelected, setLastSelected] = useState(null);
    const [flattenedFilters, setFlattenedFilters] = useState([]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    }

    /** Options is an array of options not just one. So we need to flatten this **/
    useEffect(() => {
        if (props.filters) {
            let tempFilters = [];

            props.filters.forEach(item => {
                if (Array.isArray(item)) {
                    item.forEach(subItem => {
                        if (subItem.tabContent.items.length) {
                            tempFilters.push(subItem);
                        }
                    });
                } else {
                    tempFilters.push(item);
                }
            });
            setFlattenedFilters(tempFilters);
        }
    }, [props.filters]);

    const activeFiltersBar = filters.length > 0 ? (
        <ListingActiveFiltersBar
            filters={filters.map((filter) => ({
                key: filter.id,
                label: getFilterLabel(filter),
                element: filter,
            }))}
            onRemove={(item) => dispatch({type: 'filter_remove', item: item})}
            onResetAll={() => dispatch({type: 'filters_reset'})}
        />
    ) : null;

    return (
        <Box sx={{ marginBottom: props.withoutBottomMargin ? 0 : 3 }}>
            <FilterBlock titleId={"merchandising.show.label.filters.title"} footer={activeFiltersBar}>
                {!props.loaded &&
                    <div className={classes.filterLoading}>
                        <BeatLoader
                            sizeUnit={"px"}
                            size={12}
                            color={primaryColor}
                            loading={true}
                        />
                    </div>
                }
                {(props.loaded && flattenedFilters) &&
                    <>
                        <TabContext value={value}>
                            <div className={classes.filterMenu}>
                                <TabList
                                    onChange={handleChange}
                                    variant="scrollable"
                                    classes={{root: classes.tabsRoot, indicator: classes.tabsIndicator}}
                                >
                                    {flattenedFilters.map((filter, index) => {
                                        return <Tab
                                            label={<FormattedMessage id={"merchandising.show.label.filters.title." + filter.tabTitle} defaultMessage={filter.tabTitle} />}
                                            value={index.toString()}
                                            key={index}
                                            disableRipple
                                            classes={{root: classes.tabRoot, selected: classes.tabSelected}}
                                        />
                                    })}
                                </TabList>
                            </div>
                            {flattenedFilters.map((filter, index) => {
                                const tabContent = filter.tabContent;
                                return (
                                    <TabPanel
                                        key={index}
                                        value={index.toString()}
                                        sx={{ '&.MuiTabPanel-root': {padding: 0}, overflowX: 'auto' }}
                                    >
                                        <tabContent.component
                                            items={tabContent.items}
                                            lastSelected={lastSelected}
                                            setLastSelected={setLastSelected}
                                        />
                                    </TabPanel>
                                );
                            })}
                        </TabContext>
                    </>
                }
            </FilterBlock>
        </Box>
    );
}

export default withStyles(filterMenuStyle)(Filters);
